import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import Page from '../../../../Types/Page';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import {
  FILTER_BY_HEIGHT_SHORT,
  FILTER_BY_HEIGHT_REGULAR,
} from '../../../../Util/GlobalConstants';
import { Feature, isFeatureEnabled } from '../../../../config/FeaturesConfig';

interface LighthouseFilterByProps {
  shortFilterBy: boolean;
  customDate: boolean;
  page: string;
}
export const LighthouseFilterBy: React.FC<LighthouseFilterByProps> = ({
  shortFilterBy,
  customDate,
  page,
}: LighthouseFilterByProps): React.ReactElement => {
  if (
    page === Page.TEAM &&
    isFeatureEnabled(Feature.CUSTOM_DATE_RANGE) &&
    shortFilterBy
  ) {
    return (
      <Row>
        <div style={{ height: FILTER_BY_HEIGHT_SHORT }}>
          <Text alignment='justify'>
            <FormattedMessage
              id='cs_perfportal_filterBy'
              defaultMessage='Filter by'
            />
          </Text>
        </div>
      </Row>
    );
  }
  return (
    <Column>
      <div style={{ height: 5 }}></div>
      <div style={{ height: FILTER_BY_HEIGHT_REGULAR }}>
        <Text alignment='justify'>
          <FormattedMessage
            id='cs_perfportal_filterBy'
            defaultMessage='Filter by'
          />
        </Text>
      </div>
    </Column>
  );
};

export default LighthouseFilterBy;
